import { useEffect, useRef, useState } from 'react'

export interface INumberPickerProps {
	data?: any,
	active?: string,
	setActive: (val: string) => void
	exact?: string,
	setExact: (val: any) => void
}

const options = [
	{label: 'Any', value: ''},
	{label: '1', value: '1'},
	{label: '2', value: '2'},
	{label: '3', value: '3'},
	{label: '4', value: '4'},
	{label: '5', value: '5'},
]

const NumberPicker = ({ data, exact, setExact, active, setActive }: INumberPickerProps) => {

	return (
		<div>
			<div className="listing-filter-picker">
				{options?.map((item, index) => (
					<button
						key={index}
						className={[active == item.value ? 'active hover-accent-bg' : '', (!active && index == 0 ? 'active hover-accent-bg' : ''), 'btn'].join(' ')}
						onClick={() => setActive(item.value)}
					>
						{item?.label}
						{(item?.label !== 'Any' && exact !== 'true') && "+"}
					</button>
				))}
			</div>
			<div className="form-check form-check-inline input--radio">
				<label className="pointer mb-0">
					{/*
  					// @ts-ignore */}
					<input data-val-required="The InsightsOptInChecked field is required." id="formModel_InsightsOptInChecked" name="formModel.InsightsOptInChecked" type="checkbox" checked={exact}
						onChange={(e) => {
							setExact(e.target.checked ? 'true' : null)
						}} />
					<span className="checkmark"></span>
					<span>Use exact values</span>
				</label>
			</div>
		</div>
	)
}

export default NumberPicker
